module.exports = __webpack_public_path__ + "img/user.4f3def45.svg";